/**
 * Marca Vega — "V" triangular com duas hastes que convergem (funil de pipeline abstrato).
 * Reproduzido do mock (design/handoff/pipeline/project/app.jsx, componente VegaMark).
 */
export function VegaMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      role="img"
      aria-label="Vega"
    >
      <path
        d="M3.5 4.5 L12 19.5 L20.5 4.5"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="square"
        strokeLinejoin="miter"
      />
      <path
        d="M7.5 4.5 L12 13.5 L16.5 4.5"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="square"
        strokeLinejoin="miter"
        opacity="0.55"
      />
    </svg>
  );
}
